import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { useValue } from '@morningtrain/react-resources'

function WhenModelValue (props) {
  const { name, condition, children } = props
  const value = useValue(name)

  let shouldRender = value === condition

  if (condition && typeof condition === 'function') {
    shouldRender = condition(value)
  }

  if (typeof condition === 'undefined') {
    shouldRender = !!value
  }

  return shouldRender ? children : null
}

WhenModelValue.propTypes = {
  name: PropTypes.string.isRequired,
  condition: PropTypes.any
}

export default observer(WhenModelValue)
